// The board's own pages: Setup and Theme (157, decision C11).
//
// Shaped like WheelNav and hung under Board in the rail the way the Wheel's
// pages hang under Wheel. Setup is every role's (a Viewer reads it); Theme is
// Nova's, so a Viewer sees one item here and the rail opens Board on Setup.

import type { ReactNode } from "react";
import type { BoardPanel } from "../routes/route.js";

export type BoardNavProps = {
  readonly panel: BoardPanel;
  readonly onOpen: (panel: BoardPanel) => void;
  readonly className?: string;
  /** Which of the two roleAccess.ts offers this reader. Omitted, both. */
  readonly offer?: { readonly setup: boolean; readonly theme: boolean };
};

export const BOARD_NAV_ITEMS: readonly { readonly panel: BoardPanel; readonly label: string }[] = [
  { panel: "setup", label: "Setup" },
  { panel: "theme", label: "Theme" },
];

export function BoardNav({ panel, onOpen, className, offer }: BoardNavProps): ReactNode {
  const items = BOARD_NAV_ITEMS.filter((item) => offer === undefined || offer[item.panel]);
  return (
    <nav className={className === undefined ? "seg2" : className} aria-label="Board">
      {items.map((item) => (
        <button
          key={item.panel}
          type="button"
          aria-current={item.panel === panel ? "page" : undefined}
          onClick={() => onOpen(item.panel)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
